export enum SignedinState {
  UNRESOLVED = "UNRESOLVED",
  SIGNEDIN = "SIGNEDIN",
  SIGNEDOUT = "SIGNEDOUT",
}
